import { groupLifeService } from '@/services';
import type { GroupLifeRejectAnalysisResponse } from '@/services/group-life';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  policyId: string;
  description: string;
};

export function useRejectGroupLifeAnalysis() {
  const queryClient = useQueryClient();

  return useMutation<GroupLifeRejectAnalysisResponse, Error, Variables>({
    mutationKey: ['group-life', 'reject-analysis'],
    mutationFn: async ({ policyId, description }) => {
      const response = await groupLifeService.rejectAnalysis(policyId, description);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao recusar cotação em análise');
      }
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['group-life', 'quote-details', variables.policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
      queryClient.invalidateQueries({ queryKey: ['quotes-status-count'] });
      queryClient.invalidateQueries({
        queryKey: ['quote-document', variables.policyId],
      });
    },
  });
}
